import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

class SummarySocialReportService {
    payout(year: number) {
        return apiClient.get<ArrayBuffer>(
            `${BASE_URL}/api/v1/summary/payout`,
            { params: { year }, responseType: "arraybuffer" }
        );
    }

    social(year: number) {
        return apiClient.get<ArrayBuffer>(
            `${BASE_URL}/api/v1/summary/social`,
            { params: { year }, responseType: "arraybuffer" }
        );
    }
}

export default new SummarySocialReportService();

